// =====================================
//
//   付款結果 Controller
//   Author: Gray
//   createtime: 2016 / 09 / 13
//
// =====================================

window.InifECMobileApp.controller("PaymentResultController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'UserService', 'OrderService',
    function($scope, $state, $timeout, $rootScope, $stateParams, UserService, OrderService) {

        var init = function() {
            
            $scope.isLoading = true;

            // 通知app 關掉付款web view
            var msg = {
                type: 'paymentFinishedCallback',
            }

            msg = JSON.stringify(msg);

            // post state change message
            if( window.WebViewBridge !== undefined && window.WebViewBridge.postMessage){
                window.WebViewBridge.postMessage(msg);
            } else if( window.WebViewBridge !== undefined && window.WebViewBridge.send){
                window.WebViewBridge.send(msg);
            }

            if(!$scope.isError) {

                $timeout(function() {
                    checkResult();
                }, 500);

            } else {
                UserService.getUserInfo().then(function(result) {
                    $scope.isLogin = true;
                    $scope.isLoading = false;
                }, function(error) {
                    $scope.isLogin = false;

                    $state.go(window.STATES.HOME);
                });
            }
        }

        var checkResult = function() {

            if($scope.checkCount++ > 4) {
                $scope.isLoading = false;
                $scope.isError = true;
                $scope.errorcode = "系統錯誤";
                $scope.errordesc = "系統發生無法預期錯誤，請重新再試";
                return;
            }

            OrderService.getOrderInfo($scope.orderid).then(function(result) {

                if(result && result.ispaid) {

                    $state.go(window.STATES.ORDER, {
                        orderid: $scope.orderid
                    });

                } else if(result && !result.ispaid) {

                    $timeout(function() {
                        checkResult();
                    }, 500);

                } else {
                    $scope.isLoading = false;
                    $scope.isError = true;
                    $scope.errorcode = "系統錯誤";
                    $scope.errordesc = "系統發生無法預期錯誤，請重新再試";
                }

            }, function(error) {

                $scope.isLoading = false;
                $scope.isError = true;
                $scope.errorcode = "系統錯誤";
                $scope.errordesc = "系統發生無法預期錯誤，請重新再試";

            });
        }

        //==========================
        //  Events
        //==========================
        $scope.$on("LOGOUT_SUCCESS", function(event, data) {
            init();
        });

        //==========================
        //  Members
        //==========================
        $scope.orderid = $stateParams.orderid;
        $scope.errorcode = $stateParams.errorcode;
        $scope.errordesc = $stateParams.errordesc;
        $scope.isError = $stateParams.errorcode;
        $scope.checkCount = 0;


        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        init();

    }
]);